function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import EnhancedCompressor from '../EnhancedCompressor';
import EnhancedImageEditor from '../EnhancedImageEditor';
import { RemoteImageDownloader, LoadingStatus } from '../../plugins';
import prepareFileName from '../../utils/prepareFileName';
import TusdConfig from './TusdConfig';
import CompressorConfig from './CompressorConfig';
import ImageEditorConfig from './ImageEditorConfig';
import ImageEditorHandler from './ImageEditorHandler';
import FileTypesConfig from './FileTypesConfig';
import UploadCompleteHandler from './UploadCompleteHandler';
import EventPresenter from '../presenters/EventPresenter';
import FilePresenter from '../presenters/FilePresenter';

var defaultFn = function defaultFn() {};

var FILENAME_LENGTH_LIMIT = 250;

var renameFiles = function renameFiles(files) {
  var updatedFiles = {};
  Object.keys(files).forEach(function (fileID) {
    updatedFiles[fileID] = files[fileID];

    var _prepareFileName = prepareFileName(updatedFiles[fileID]),
        extension = _prepareFileName.extension,
        displayName = _prepareFileName.displayName,
        uniqueName = _prepareFileName.uniqueName;

    updatedFiles[fileID].extension = extension;
    updatedFiles[fileID].displayName = displayName;
    updatedFiles[fileID].name = uniqueName;
    updatedFiles[fileID].meta.name = uniqueName;

    if (updatedFiles[fileID].data) {
      // In order for Compressor to work, a 'data' should have a 'name' attribute
      try {
        updatedFiles[fileID].data.name = uniqueName;
      } catch (err) {// no-op. This can happen when there is no 'name' setter on the data object. Ex: File object
      }
    }

    updatedFiles[fileID].meta.source = updatedFiles[fileID].meta.source || updatedFiles[fileID].source;
  });
  return updatedFiles;
};

var validateFileNames = function validateFileNames(uppy, files) {
  var valid = true;
  Object.keys(files).forEach(function (fileID) {
    var currentName = files[fileID].meta.name;

    if (!currentName || currentName.length < 1) {
      uppy.info('Filename is required.', 'error');
      valid = false;
    }

    if (currentName.length > FILENAME_LENGTH_LIMIT) {
      uppy.info("Filename cannot exceed ".concat(FILENAME_LENGTH_LIMIT, " characters."), 'error');
      valid = false;
    }
  });
  return valid;
};

var convertOptionsPresent = function convertOptionsPresent(opts) {
  return opts.convertOptions && Object.keys(opts.convertOptions).length > 0;
};

var preprocessFile = function preprocessFile(uppy, file) {
  // don't allow arbitrary uploads
  if (!uppy.opts.restrictions.allowedFileTypes) {
    uppy.log("Aborting upload because allowed file types aren't set", 'warning');
    uppy.info('This file is not permitted', 'error');
    return false;
  }

  if (file.isRemote && file.type.startsWith('image/') && (!uppy.opts.autoProceed || convertOptionsPresent(uppy.opts))) {
    // Allow editing/compressing of a remote image:
    //  when auto proceed is disabled (allow editor)
    //  or when convert options aren't present (compressor)
    uppy.getPlugin('RemoteImageDownloader').addFile(file);
    return false;
  }

  return file;
}; // callbackHandlers
// Returns an object callback functions.
// It constructs the callbacks with scoped data passed as the second argument. It interacts
// with the `cachedFilePresenters` array argument by pushing new FilePresenters during
// `onBeforeUpload` and updating cached FilePresenters during subsequent callbacks.


var callbackHandlers = function callbackHandlers(_ref, _ref2) {
  var _ref$onBeforeUpload = _ref.onBeforeUpload,
      _onBeforeUpload = _ref$onBeforeUpload === void 0 ? defaultFn : _ref$onBeforeUpload,
      _ref$onComplete = _ref.onComplete,
      _onComplete = _ref$onComplete === void 0 ? defaultFn : _ref$onComplete,
      _ref$onSuccess = _ref.onSuccess,
      _onSuccess = _ref$onSuccess === void 0 ? defaultFn : _ref$onSuccess,
      _ref$onError = _ref.onError,
      _onError = _ref$onError === void 0 ? defaultFn : _ref$onError,
      _ref$onFileRemoved = _ref.onFileRemoved,
      _onFileRemoved = _ref$onFileRemoved === void 0 ? defaultFn : _ref$onFileRemoved;

  var cachedFilePresenters = _ref2.cachedFilePresenters,
      logger = _ref2.logger;
  return {
    onBeforeUpload: function onBeforeUpload(filePresenters) {
      cachedFilePresenters.push.apply(cachedFilePresenters, _toConsumableArray(filePresenters));
      var event = new EventPresenter({
        filePresenters: filePresenters
      });
      logger.info('onBeforeUpload', _objectSpread({}, event));

      _onBeforeUpload(event.serialize());
    },
    onComplete: function onComplete(filePresenters) {
      FilePresenter.updateEachByIdAndRecache(filePresenters, cachedFilePresenters);
      var event = new EventPresenter({
        filePresenters: filePresenters
      });
      logger.info('onComplete', _objectSpread({}, event));

      _onComplete(event.serialize());
    },
    onSuccess: function onSuccess(filePresenters) {
      FilePresenter.updateEachByIdAndRecache(filePresenters, cachedFilePresenters);
      var event = new EventPresenter({
        filePresenters: filePresenters
      });
      logger.debug('onSuccess', _objectSpread({}, event));

      _onSuccess(event.serialize());
    },
    onError: function onError(filePresenters) {
      FilePresenter.updateEachByIdAndRecache(filePresenters, cachedFilePresenters);
      var event = new EventPresenter({
        filePresenters: filePresenters
      });
      logger.error('onError', _objectSpread({}, event));

      _onError(event.serialize());
    },
    onFileRemoved: function onFileRemoved(filePresenters) {
      FilePresenter.updateEachByIdAndRecache(filePresenters, cachedFilePresenters);
      var event = new EventPresenter({
        filePresenters: filePresenters
      });
      logger.debug('onFileRemoved', _objectSpread({}, event));

      _onFileRemoved(event.serialize());
    }
  };
};

var defaultLogger = {
  info: defaultFn,
  warn: defaultFn,
  error: defaultFn,
  debug: defaultFn
};

var UppyClient = function UppyClient() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pluginsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var logger = props.logger || defaultLogger;
  var cachedFilePresenters = [];

  var _callbackHandlers = callbackHandlers(props, {
    cachedFilePresenters: cachedFilePresenters,
    logger: logger
  }),
      onComplete = _callbackHandlers.onComplete,
      onSuccess = _callbackHandlers.onSuccess,
      onError = _callbackHandlers.onError,
      _onBeforeUpload2 = _callbackHandlers.onBeforeUpload,
      onFileRemoved = _callbackHandlers.onFileRemoved;

  var uppy = new Uppy({
    id: props.clientId || 'uppy',
    logger: logger,
    debug: props.debug,
    autoProceed: props.autoProceed,
    restrictions: {
      minFileSize: 1,
      // min 1 byte, don't allow upload an empty file
      maxFileSize: parseInt(props.maxSize, 10),
      allowedFileTypes: FileTypesConfig(props).extensions,
      maxNumberOfFiles: props.multiple ? props.maxFiles : 1
    },
    onBeforeFileAdded: function onBeforeFileAdded(file) {
      return preprocessFile(uppy, file);
    },
    onBeforeUpload: function onBeforeUpload(files) {
      if (!validateFileNames(uppy, files)) {
        return false;
      }

      var preparedFiles = renameFiles(files);
      var filePresenters = Object.values(preparedFiles).map(function (uppyFile) {
        return new FilePresenter({
          uppyFile: uppyFile,
          uploadAt: new Date()
        });
      });

      _onBeforeUpload2(filePresenters);

      return preparedFiles;
    }
  });
  uppy.setMeta({
    requestedStorePath: props.path,
    requestedStoreBucket: props.bucket,
    requestedStoreAccess: props.storeAccess
  });

  var plugins = _toConsumableArray(pluginsList);

  var tusConfig = TusdConfig(props);
  plugins.push([LoadingStatus, {}]);
  plugins.push([RemoteImageDownloader, tusConfig]);
  plugins.push([Tus, tusConfig]);
  plugins.push([EnhancedImageEditor, ImageEditorConfig(props)]);

  if (convertOptionsPresent(props)) {
    uppy.opts.convertOptions = props.convertOptions;
    plugins.push([EnhancedCompressor, CompressorConfig(props)]);
  }

  plugins.forEach(function (p) {
    return uppy.use.apply(uppy, _toConsumableArray(p));
  });
  uppy.on('complete', UploadCompleteHandler(tusConfig, onComplete, onSuccess, onError));
  uppy.on('file-removed', function (uppyFile, reason) {
    return onFileRemoved([new FilePresenter({
      uppyFile: uppyFile,
      reason: reason
    })]);
  });
  var editorHandler = ImageEditorHandler(uppy);
  uppy.on('file-editor:start', editorHandler.onStart);
  uppy.on('file-editor:complete', editorHandler.onFinish);
  uppy.on('file-editor:cancel', editorHandler.onFinish);
  return uppy;
};

export default UppyClient;